module.exports = "/images/blister-7.png";